import { SWRConfiguration } from 'swr';

import {
  GET_SHORT_ABSENCES_SWR_KEY,
  ShortAbsence,
  getShortAbsences,
} from '~/data/absences/index';
import { UseSWROutput, useSWR } from '~/hooks/useSWR';

type PropsType = {
  employeeId: number;
  period?: 'historical';
};

export const useGetShortAbsences = (
  props: PropsType,
  swrConfig?: SWRConfiguration,
  disable?: boolean,
): UseSWROutput<ShortAbsence[]> => {
  const { employeeId, period } = props;

  const isEnabled = !disable;

  return useSWR(
    isEnabled ? [GET_SHORT_ABSENCES_SWR_KEY, employeeId, period] : null,
    ([key_, employeeId]) => getShortAbsences(employeeId, period),
    swrConfig,
  );
};
